import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import NotificationCore from "@/modules/NotificationCore/NotificationCore";
import { ISendCrkErrorData } from "@/api/e-imzo/interface";
import { $postCrkErrorMessage } from "@/api/e-imzo";
import AppConfig from "@/core/app.config";
import { CrkStatuses } from "@/mixins/crk/interface";

@Component
export default class CrkClient extends Vue {

	isLoaded: boolean = false

	isError: boolean = false

	isConnected: boolean = false

	WS_TYPE_REQUEST = 0;
	WS_TYPE_RESPONSE = 1;
	WS_TYPE_NOTIFY = 2;

	ISIGNER_ERROR_CODES = {
		UNKNOWN: 0,
		SUCCESS: 1,
		UNKNOWN_TYPE: 2,
		UNKNOWN_FUNC: 3,
		INVALID_REQUEST: 4,
		ARGS_REQIURED: 5,
		ARGS_COUNT_MISMATCH: 6,
		ARG_REQIURED: 7,
		ARG_COULD_NOT_BE_EMPTY: 8,
		INVALID_PATH: 9,
		KEYS_ARE_NOT_PAIR: 10,
		INVALID_SUBJECT_DN: 11,
		INVALID_SERVER_TOKEN: 12,
		KEY_NOT_FOUND: 13,
		KEY_PASSWORD_INCORRECT: 14,
		UNKNOWN_KEY_FORMAT: 15,
		COULD_NOT_GENERATE_SIGN: 16,
		INVALID_CERTIFICATE: 17,
		ACTION_CANCELED: 18,
		INVALID_PRIVATE_KEY: 19,
		COULD_NOT_WRITE: 20,
		USB_TOKEN_NOT_INSTALLED: 21,
		USB_TOKEN_NOT_CONNECTED: 22,
		USB_TOKEN_ERROR: 23,
		USB_TOKEN_PASSWORD_INCORRECT: 24,
	};

	ISIGNER_FUNC_CODES = {
		METHODS_LIST: 0,
		VERSION: 1,
		KEYLIST: 2,
		REMOVABLELIST: 3,
		HASH: 4,
		SIGN: 5,
		KEYPAIRGEN: 6,
		SAVEKEY: 7,
		CHANGEPIN: 8,
		REENCRYPT: 9,
	};

	onNotify: any = null;

	webSocket: WebSocket | null = null;
	keepAlive = false;
	callbacks: any = {};
	digest = '';
	signature = '';
	certificate = '';

	password: string = '';

	errorMessage: string = '';

	errorState: number = NaN;

	errorMessagePassword: string = '';

	@Prop({ type: [ Object, String ], default: '' })
	readonly signatureData!: any;

	toast(v: string): any {
		return NotificationCore.addToast(v, 'error');
	}

	iSignerLoad(): Promise<any> {
		return new Promise((resolve, reject) => {
			let URL = window.location.protocol.toLowerCase() === "https:"
				? "wss://127.0.0.1:44443"
				: "ws://127.0.0.1:44480";

			this.webSocket = new WebSocket(URL);
			this.isError = false;

			this.webSocket.onerror = (event: any) => {
				if (this.webSocket) this.webSocket.close();

				AppConfig.eImzoLogging && console.log("Failed. Error code: " + event.code);

				this.errorMessage = this.$t('crk.errorCrk') as string;
				this.isError = true;
				this.isConnected = false;

				reject();
			};

			this.webSocket.onclose = (event) => {
				if (event.code !== CrkStatuses.ERROR_MODULE) return;

				AppConfig.eImzoLogging && console.log("Failed. Error code: " + event.code);

				this.errorState = event.code;
				this.errorMessage = this.$t('crk.errorApp') as string;

				reject();
			};

			this.webSocket.onmessage = (event) => {
				let resp = JSON.parse(event.data);

				if (('type' in resp) && resp.type == this.WS_TYPE_RESPONSE) {
					if ('cbid' in resp && this.callbacks[resp.cbid]) {
						if (!('code' in resp)) {
							this.requestErrorValidCrk(JSON.stringify('Invalid response:' + event.data))
						}
						let callback = this.callbacks[resp.cbid];

						if (this.webSocket) this.webSocket.close();

						delete this.callbacks[resp.cbid];

						if (resp.code == this.ISIGNER_ERROR_CODES.SUCCESS) {
							callback(resp.data);
						} else {
							if (typeof resp.data === 'string') {
								if (resp.data.indexOf('ikey: unit not found') > -1) {
									this.errorMessagePassword = this.$t('crk.errorKeyNotFound') as string;
								} else if (resp.code === this.ISIGNER_ERROR_CODES.USB_TOKEN_PASSWORD_INCORRECT) {
									this.errorMessagePassword = this.$t('crk.errorWrongPassword') as string;
									this.password = '';
								} else {
									this.requestErrorValidCrk(JSON.stringify(event.data))
								}
								throw event.data;
							} else {
								throw JSON.stringify(event.data);
							}
						}
					} else {
						this.requestErrorValidCrk('cbid not found')
					}
				} else if (('type' in resp) && resp.type == this.WS_TYPE_NOTIFY) {
					if (typeof this.onNotify === 'function') {
						this.onNotify.call(this, resp);
					} else {
						AppConfig.eImzoLogging && console.log("we have notification (code: " + resp.code + "; data: " + resp.data + ")");
					}
					if (this.errorMessage) {
						this.requestErrorValidCrk(JSON.stringify(event.data))
						AppConfig.eImzoLogging && console.log('NOTIFY: ' + event.data)
					}
				}
			};

			this.webSocket.onopen = () => {
				this.isConnected = true;

				resolve(undefined);
			};
		})
	}

	iSignerGetSubjectField(subject: any, fieldName: any) {
		if (subject == null || subject.lenth == 0) {
			return '';
		}

		let fields = subject.split(';');

		for (let i = 0; i < fields.length; i++) {
			let field = fields[i].split('=');

			if (i === 0) {
				field = fields[i].split('/');

				let fieldEnd = field[2].split('=');

				if (field[0] === fieldName) return `${ field[0] }/${ field[1] }/`

				if (fieldEnd[0] === fieldName) return fieldEnd[1]
			}

			if (field.length == 2) {
				if (field[0] == fieldName)
					return field[1];
			}
		}

		return '';
	}

	iSignerListKeys(): Promise<any> {
		return new Promise((resolve: any) => {
			this.iSignerLoad()
				.then(() => {
					let params = {
						type: this.WS_TYPE_REQUEST,
						func: this.ISIGNER_FUNC_CODES.KEYLIST,
						cbid: Math.random(),
						args: {},
					};

					AppConfig.eImzoLogging && console.log(params, 'iSignerListKeys');

					this.iSignerSend(params, resolve);
				}, resolve);
		});
	}

	iSignerSend(activeObj: any, callback: any) {
		if (typeof callback === 'function') {
			this.callbacks[activeObj.cbid] = callback;

			const mjson = JSON.stringify(activeObj);
			if (this.webSocket) this.webSocket.send(mjson);
		}
	}

	iSignerHash(data: any, type: any): Promise<any> {
		return new Promise<any>(resolve => {
			this.iSignerLoad().then(() => {
				let params = {
					type: this.WS_TYPE_REQUEST,
					func: this.ISIGNER_FUNC_CODES.HASH,
					cbid: Math.random(),
					args: {
						data, type
					},
				};

				AppConfig.eImzoLogging && console.log(params, 'iSignerHash')

				this.iSignerSend(params, resolve);
			})
		})
	}

	iSignerSign(serverToken: string, hash: string, iKey: string, resolve: any, password?: string) {
		password = password || this.password;

		this.iSignerLoad().then(() => {
			let params = {
				type: this.WS_TYPE_REQUEST,
				func: this.ISIGNER_FUNC_CODES.SIGN,
				args: {
					data: hash,
					snum: iKey,
					stok: serverToken,
					pass: password
				},
				cbid: Math.random()
			};

			AppConfig.eImzoLogging && console.log(params, 'iSignerSign');

			this.iSignerSend(params, resolve);
		})
	}

	iSignerVersion(resolve: any) {
		this.iSignerLoad().then(() => {
			let params = {
				type: this.WS_TYPE_REQUEST,
				func: this.ISIGNER_FUNC_CODES.VERSION,
				args: {},
				cbid: Math.random()
			};

			AppConfig.eImzoLogging && console.log(params, 'iSignerVersion')

			this.iSignerSend(params, resolve);
		})
	}

	iSignerError(): Promise<any> {
		return new Promise(resolve => {
			this.iSignerVersion(resolve)
		})
	}

	requestErrorValidCrk(errorState: string) {
		this.iSignerError().then(version => {

			this.toast(this.$t('crk.errorConfirmCrk') as string)

			$postCrkErrorMessage(this.getErrorData(errorState, version.version))
		})
	}

	getErrorData(errorMessage: string, version: any): ISendCrkErrorData {
		return {
			paymentOrderId: this.signatureData.paymentOrderId ? this.signatureData.paymentOrderId : undefined,
			errorMessage,
			userAgent: window.navigator.userAgent,
			iCrypterVersion: version,
		}
	}

	@Watch('password')
	onPasswordChange() {
		if (this.password) this.errorMessagePassword = '';
	}

}